(() => {
  const root = document.querySelector(".lp-baseball");
  if (!root || typeof window.jQuery === "undefined") return;

  const $ = window.jQuery;
  const $root = $(root);
  const mq = window.matchMedia("(max-width: 768px)");

  const applySrc = (el, key) => {
    const next = el.getAttribute(key);
    if (next) el.setAttribute("src", next);
  };

  const setHeaderTheme = (darkText) => {
    $root.find("[data-src-light][data-src-dark]").each((_, el) => {
      applySrc(el, darkText ? "data-src-dark" : "data-src-light");
    });
    $root.find(".lp-header .header-inner ul li a").css("color", darkText ? "#000000" : "#ffffff");
  };

  $root.find(".menu-bar").on("click", function () {
    $(this).toggleClass("active");
    $(this).closest(".sp-link").next("ul").fadeToggle(400);
  });
  $root.find(".header-inner ul li a").on("click", function () {
    if (!mq.matches) return;
    $root.find(".menu-bar").removeClass("active");
    $root.find(".header-inner ul").fadeOut(400);
  });

  $root.find('a[href^="#"]').on("click", function (event) {
    const href = $(this).attr("href");
    const target = href === "#" || href === "" ? root : root.querySelector(href);
    if (!target) return;
    event.preventDefault();
    const top = target.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({ top, behavior: "smooth" });
  });

  $root.find(".contents01-inner").slick({
    speed: 1500,
    autoplay: true,
    autoplaySpeed: 3000,
    fade: true,
    dots: true,
    swipe: false,
    useCSS: false,
    touchMove: false,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    pauseOnHover: false,
    responsive: [{ breakpoint: 769, settings: { swipe: true, touchMove: true, speed: 500 } }],
  });

  const specSlick = {
    speed: 500,
    autoplay: false,
    dots: true,
    swipe: false,
    useCSS: false,
    touchMove: false,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    pauseOnHover: false,
    responsive: [{ breakpoint: 769, settings: { arrows: false, swipe: true, touchMove: true, speed: 200 } }],
  };
  $root.find(".contents04-inner02").slick(specSlick);
  $root.find(".contents04-inner03").slick(specSlick);

  if (!mq.matches) {
    const mainSlider = $root.find(".contents07-inner .item-area");
    const thumbnailSlider = $root.find(".contents07-inner02 .item-area");
    mainSlider.slick({
      autoplay: false,
      speed: 500,
      arrows: false,
      asNavFor: thumbnailSlider,
    });
    thumbnailSlider.slick({
      slidesToShow: 4,
      speed: 500,
      variableWidth: true,
      asNavFor: mainSlider,
      focusOnSelect: true,
    });

    const mainSlider2 = $root.find(".item-img .main-img");
    const thumbnailSlider2 = $root.find(".item-img .thumbnail-img");
    mainSlider2.slick({
      autoplay: false,
      speed: 500,
      asNavFor: thumbnailSlider2,
    });
    thumbnailSlider2.slick({
      slidesToShow: 3,
      speed: 500,
      arrows: false,
      variableWidth: true,
      asNavFor: mainSlider2,
      focusOnSelect: true,
    });

    thumbnailSlider.find(".slick-slide").on("click", function () {
      const index = $(this).attr("data-slick-index");
      thumbnailSlider.slick("slickGoTo", index, false);
      mainSlider2.slick("slickGoTo", 0, true);
    });
    $root.find(".contents07-inner02 .slick-arrow").on("click", () => {
      mainSlider2.slick("slickGoTo", 0, true);
    });
    mainSlider2.on("afterChange", (_event, _slick, currentSlide) => {
      thumbnailSlider2.find(".slick-slide").removeClass("slick-current");
      thumbnailSlider2.find(`.slick-slide[data-slick-index="${currentSlide}"]`).addClass("slick-current");
    });
  }

  const updateHeader = () => {
    if (mq.matches) return;
    const h01 = $root.find(".contents01").outerHeight() || 0;
    const h03 = $root.find(".contents03").outerHeight() || 0;
    const h04 = $root.find(".contents04").outerHeight() || 0;
    setHeaderTheme(window.scrollY > h01 + h03 + h04);
  };
  updateHeader();
  window.addEventListener("scroll", updateHeader, { passive: true });

  $root.find(".js-popup").on("click", function () {
    if (!mq.matches) return;
    const src = $(this).attr("src");
    $root.find("#itemPopupModal img").attr("src", src);
    $root.find("#itemPopupModal").fadeIn();
  });
  $root.find("#itemPopupModal .overlay, #itemPopupModal .popup-content .close").on("click", () => {
    $root.find("#itemPopupModal").fadeOut();
  });

  const fadeIns = root.querySelectorAll(".fade-in");
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) entry.target.classList.add("active");
      });
    },
    { threshold: 0.3 }
  );
  fadeIns.forEach((el) => observer.observe(el));
})();
